// src/Redux/UtilsRedux/uploadToFirebase.js
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../../firebase'; // you already export storage

/**
 * Upload a file to Firebase Storage and return the public URL.
 * @param {File|Blob} file
 * @param {string} pathPrefix e.g. `dailyLogs/${uid}/${projectId}`
 */
export async function uploadToFirebase(file, pathPrefix = 'misc') {
  if (!file) return null;
  const safeName = file.name?.replace(/\s+/g, '_') || 'upload.bin';
  const ts = Date.now();
  const path = `${pathPrefix}/${ts}_${safeName}`;
  const storageRef = ref(storage, path);
  const snap = await uploadBytes(storageRef, file);
  const url = await getDownloadURL(snap.ref);
  return url;
}
